<template>
  <div class="warpper">
    <!-- 搜索 -->
    <div style="margin-bottom: 10px">
      <el-form :model="searchForm" ref="searchForm" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item
              label="巡更点名称"
              prop="patrolPointTitle"
              label-width="100px"
            >
              <el-input
                v-model="searchForm.patrolPointTitle"
                size="medium"
                placeholder="请输入巡更点名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="巡更点位置"
              prop="patrolPointAddress"
              label-width="100px"
            >
              <el-input
                v-model="searchForm.patrolPointAddress"
                size="medium"
                placeholder="请输入巡更点位置"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="设备编号"
              prop="patrolPointNumber"
              label-width="100px"
            >
              <el-input
                v-model="searchForm.patrolPointNumber"
                size="medium"
                placeholder="请输入巡更点设备编号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="	巡更人姓名"
              prop="patrolUserName"
              label-width="100px"
            >
              <el-input
                v-model="searchForm.patrolUserName"
                size="medium"
                placeholder="请输入巡更人姓名"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item
              label="巡更路线"
              prop="patrolLevelId"
              label-width="100px"
            >
              <el-select
                clearable filterable
                size="medium"
                v-model="searchForm.patrolRouteId"
                placeholder="请选择巡更路线"
              >
                <el-option
                  v-for="item in routeList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-top: 4px">
            <el-button
              size="small"
              @click="onLoad(1)"
              type="primary"
              icon="el-icon-search"
              style="width: 90px; margin-left: 15px"
              >搜索</el-button
            >
            <el-button
              size="small"
              @click="restSearch"
              type="danger"
              style="width: 90px"
              >重置</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="downloadurl"
              style="width: 90px"
              >导出</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column type="expand" label="展开" width="80px">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-row
              v-for="(item, ind) in props.row.patrolLevelContent"
              :key="ind"
            >
              <el-col :span="24">
                <el-form-item label="检查内容">
                  <span style="color: #333; font-weight: border">{{
                    item.name
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="检查描述">
                  <span style="color: #333; font-weight: border">{{
                    props.row.patrolDes
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="imgList" v-viewer>
                  <img :src="item" alt="" v-for="(item,ind) in props.row.patrolImg ? props.row.patrolImg.split(',') : []" :key="ind">
                </div>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="patrolPointNumber" label="设备编号" align="center">
      </el-table-column>
      <el-table-column
        prop="patrolPointTitle"
        label="巡更点名称"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="巡更状态"
        align="center"
        :formatter="statusType"
      >
      </el-table-column>
      <el-table-column
        prop="patrolLevelParentTitle"
        label="一级分类"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="patrolLevelTitle" label="二级分类" align="center">
      </el-table-column>
      <el-table-column prop="patrolUserName" label="巡更人" align="center">
      </el-table-column>
      <el-table-column prop="patrolPhone" label="巡更人电话" align="center">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center">
      </el-table-column>     
    </el-table>
    <!-- 分页器 -->
    <div class="block" style="margin-top: 15px">
      <el-pagination
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    patrolTaskDetail: Object,
  },
  data() {
    return {
      searchForm: {
        patrolRouteId: "",
        patrolTaskId: "",
        patrolPointTitle:"",
        patrolUserName:"",
        patrolPointNumber:'',
        patrolPointAddress:'',
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      routeList: [],
    };
  },
  mounted() {
    this.searchForm.patrolRouteId =  this.patrolTaskDetail.patrolRouteId ? this.patrolTaskDetail.patrolRouteId : '';
    this.searchForm.patrolTaskId = this.patrolTaskDetail.id ? this.patrolTaskDetail.id : '';
    this.onLoad();
    this.patrolRouteList();
  },
  methods: {
    downloadurl() {
      window.location.href =
        process.env.VUE_APP_UPLOAD_REAL_PATH +
        "/export/patrolTaskPoint?patrolUserName=" +
        this.searchForm.patrolUserName +
        "&patrolTaskId=" + this.searchForm.patrolTaskId +
        "&patrolRouteId=" + this.searchForm.patrolRouteId +
        "&patrolPointTitle=" + this.searchForm.patrolPointTitle +
        "&patrolPointNumber=" + this.searchForm.patrolPointNumber +
        "&patrolPointAddress=" + this.searchForm.patrolPointAddress +
        "&villageId=" +
        JSON.parse(localStorage.getItem("park_data")).id;
    },
    // 巡更路线列表
    patrolRouteList() {
      let data = {
        size: 100,
        current: 1,
      };
      this.$Apis.patrolRouteList(data).then((res) => {
        if (res.code == 200) {
          this.routeList = res.data.list;
        }
      });
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(e) {
      let data = {
        size: this.pageSize,
        current: e || this.currentPage,
        ...this.searchForm,
      };
      this.isShowloading = true;
      this.$Apis.patrolTaskPointList(data).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item) => {
            item.patrolLevelContent = item.patrolLevelContent ? JSON.parse(item.patrolLevelContent) : [];
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    //
    statusType(row) {
      if (row.status == 0) {
        return "未巡";
      } else if (row.status == 1) {
        return "正常";
      } else if (row.status == 2) {
        return "异常";
      } else if (row.status == 3) {
        return "漏巡";
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
  },
};
</script>

<style lang="scss" scoped>
.imgList {
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 100px;
    height: 100px;
    margin-right: 5px;
  }
}
</style>